export function ExpressIcon({ className }: { className?: string }) {
    return (
      <svg
        className={className}
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="56" height="56" fill="#F2F2F2" />
        <path
          d="M14.4 20.8H22.1V22.6H16.3V26.2H21.6V28H16.3V32.4H22.2V34.2H14.4V20.8ZM28.689 34.4C27.389 34.4 26.289 34.022 25.389 33.266C24.489 32.51 24.039 31.426 24.039 30.014V24.986C24.039 23.562 24.489 22.47 25.389 21.71C26.289 20.95 27.389 20.57 28.689 20.57C29.989 20.57 31.089 20.95 31.989 21.71C32.889 22.47 33.339 23.562 33.339 24.986V30.014C33.339 31.426 32.889 32.51 31.989 33.266C31.089 34.022 29.989 34.4 28.689 34.4ZM28.689 32.64C29.409 32.64 29.999 32.41 30.459 31.95C30.919 31.49 31.149 30.848 31.149 30.024V24.976C31.149 24.152 30.919 23.51 30.459 23.05C29.999 22.59 29.409 22.36 28.689 22.36C27.969 22.36 27.379 22.59 26.919 23.05C26.459 23.51 26.229 24.152 26.229 24.976V30.024C26.229 30.848 26.459 31.49 26.919 31.95C27.379 32.41 27.969 32.64 28.689 32.64ZM38.466 27.342L34.806 20.8H37.266L39.666 25.278L42.066 20.8H44.406L40.746 27.342L44.526 34.2H42.066L39.666 29.502L37.266 34.2H34.806L38.466 27.342Z"
          fill="black"
        />
      </svg>
    );
  }
  